import api from 'api';

export const loadKPIChart = api('POST /api/kpi/chart');

export const loadKPITable = api('POST /api/kpi/table');

export const exportKPIChart = api('POST /api/kpi/chart/export', {
  responseType: 'blob',
});

export const exportKPITable = api('POST /api/kpi/table/export', {
  responseType: 'blob',
});
